import React from 'react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section className="bg-light py-28 md:py-32 px-4" data-id="element-156">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center text-center" data-id="element-157">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-textDark mb-16" data-id="element-158">
          90 minutos para ordenar cómo creces.
        </h2>

        <div className="w-full max-w-3xl bg-white border border-gray-200 shadow-xl rounded-2xl p-8 md:p-12 mb-20" data-id="element-159">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left" data-id="element-160">
            <div className="flex items-start gap-4" data-id="element-161">
              <span className="text-2xl" data-id="element-162">📅</span>
              <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-163">
                En vivo por Zoom
              </span>
            </div>
            <div className="flex items-start gap-4" data-id="element-164">
              <span className="text-2xl" data-id="element-165">📆</span>
              <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-166">
                Sábado 16 de mayo de 2026
              </span>
            </div>
            <div className="flex items-start gap-4" data-id="element-167">
              <span className="text-2xl" data-id="element-168">🕙</span>
              <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-169">
                10:00 a.m. Venezuela / Miami
              </span>
            </div>
            <div className="flex items-start gap-4" data-id="element-170">
              <span className="text-2xl" data-id="element-171">👥</span>
              <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-172">
                Plazas limitadas — para que cada persona pueda intervenir sobre
                su propio caso
              </span>
            </div>
          </div>
        </div>

        <div className="w-full max-w-4xl mx-auto mb-16" data-id="element-173">
          <p className="font-serif italic text-2xl md:text-4xl text-textDark font-bold leading-tight" data-id="element-174">
            "Llevas años pagando con tu tiempo, tu energía y tu salud. Esta vez
            pagas quince dólares y te llevas el criterio."
          </p>
        </div>

        <div className="mb-16" data-id="element-175">
          <p className="text-accent font-bold text-4xl md:text-5xl tracking-tight" data-id="element-176">
            Inversión: $15 USD
          </p>
        </div>

        <p className="text-xl md:text-2xl text-textDark mb-12 max-w-3xl leading-relaxed font-medium" data-id="element-177">
          Vas a salir con más claridad, más criterio y decisiones concretas para
          dejar de operar en automático.
        </p>

        <CTAButton className="w-full md:w-auto" data-id="element-178">
          QUIERO ENTRAR A LA SESIÓN
        </CTAButton>
      </div>
    </section>;
}